import React from 'react';

// "Is Code Bundle" column: read-only checkbox reflecting the is_code_bundle boolean.
// Shown once per code (on its first/label row); non-parent codes just show an unchecked box.
const BundleIndicatorField = ({ isBundleParent, show }) => (
    <td
        className="col col-medium border-right border-dark py-3"
        style={{ verticalAlign: 'middle', textAlign: 'center' }}>
        {show && (
            <input
                type="checkbox"
                checked={!!isBundleParent}
                readOnly
                onClick={(e) => e.preventDefault()}
                title={isBundleParent ? 'Is a code bundle' : 'Not a code bundle'}
                style={{ width: '16px', height: '16px', cursor: 'default' }}
            />
        )}
    </td>
);

export default BundleIndicatorField;
